module.exports = __webpack_public_path__ + "media/images/area/feature/banner/sp/zh-hant_kyushu-da29334c3cd29738643b9b67c894e69c.jpg";